import React, { useEffect } from 'react';
import AddBinLocation from './AddBinLocationDialog.form';
import { IAddBinLocationsDialogProperties } from './AddBinLocationDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';

const AddBinLocationsDialog = (props: IAddBinLocationsDialogProperties): JSX.Element => {
    const { open, onCancel, productId, warehouseId, defaultBin, calculateBinLocationsHandler, editData, formValues } = props;
    const formSchema = AddBinLocation.Form;

    const [binLocations, setBinLocations] = React.useState<any>({
        Bin: defaultBin,
    });

    useEffect(
        () => {
            if (editData) {
                setBinLocations({
                    Quantity: editData?.Quantity,
                    Bin: editData?.Bin,
                    SaveLocation: editData?.SaveLocation ?? false,
                });
            }
        },
        [editData]);

    const okHandler = () => {
        const transformed = {
            ...formValues,
            ...(!editData && { FastLine: true })
        };
        calculateBinLocationsHandler(transformed, editData ? true : false);
    };

    const isOkEnable = formValues?.Bin;

    const getActions = () => {
        return [
            {
                title: 'Ok',
                iconName: 'CheckCircle',
                disabled: !isOkEnable,
                listener: async () => {
                    okHandler();
                }
            },
            {
                title: 'Cancel',
                isDefault: true,
                iconName: 'Cancel',
                listener: () => {
                    if (onCancel) {
                        onCancel();
                    }
                },
            },
        ];
    };

    return (
        <div>
            <FormViewModal
                open={open}
                loading={false}
                title='Bin Location Detail'
                formProps={{
                    style: {
                        width: 500,
                    },
                    formSchema: formSchema,
                    formName: 'AddBinLocationDialog',
                    productId: productId,
                    warehouse: warehouseId,
                    isWarehouseProductScoped: true,
                    initialValues: binLocations,
                    valuesSchema: binLocations,
                    fieldExtensions: ({
                        Bin: {
                            disabled: editData
                        },
                    }),
                }
                }
                actions={getActions()}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
            />
        </div>
    );
};
export default AddBinLocationsDialog;
